<template>
  <div>
    <div class="bg" v-if="show === 1" @click="showDrop"></div>
    <div class="drop-down" @click="showDrop" style="width:5vw">
      <div>{{name}}</div>
      <i class="icon-font" :style=[iconStyle]>&#xe61c;</i>
      <div class="drop-down-content" style="width:5vw" :style=[dropStyle] :class="{'up': show === 1, 'down': show === 0}">
        <div class="drop-down-list"  v-for="(data,index) in items" :key="index" @click="sendContent(data,index)" v-if="item.length > 0">
          <div class="drop-down-list-item" :class="{'drop-down-list-item-active':name === data.name}">{{data.name}}</div>
        </div>
        <div class="none-data" v-if="item.length === 0">{{prompt || '暂无数据'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaoKuo',
  data () {
    return {
      canClick: true,
      name: this.content,
      item: this.items,
      prompt: this.message,
      show: null,
      up: {
        width: '0'
      },
      iconStyle: {},
      dropStyle: {},
    }
  },
  props: ['content', 'items', 'message'],
  watch: {  
    content: function (data) {
      this.name = data
      console.log(data+"content")
    },
    items: function (data) {
      this.item = data
    }
  },
  methods: {
    sendContent: function (data) {
      this.name = data.name
      console.log(data+"sendContent")
      this.$emit('sendInfo', data)
    },
    showDrop: function () {
      this.$emit('click')
      if (this.canClick) {
        if (this.show === null) {
          this.show = 1
        } else {
          this.show = this.show === 0 ? 1 : 0
        }
        this.iconStyle.transform = this.show === 1 ? 'rotate(90deg)' : 'rotate(0)'
        if (this.show === 1) {
          this.dropStyle = {borderBottom: 'solid 1px #3b79a1'}
        } else {
          this.canClick = false
          let _this = this
          setTimeout(function () {
            _this.dropStyle = {borderBottom: 'none'}
            _this.canClick = true
          }, 500)
        }
      }
    }
  },
  destroyed () {
    this.show = null
  }
}
</script>

<style scoped>
  .drop-down{
    text-align: left;
    width: 13vw;
    height: 2.43vw;
    padding: 0.63vw;
    font-size: 0.83vw;
    color: #00d2ff;
    border: solid 0.05vw #3b79a1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 999;
  }
  .bg{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    top: 0;
    left: 0;
    z-index: 998;
  }
  .drop-down:hover{
    border: solid 0.05vw #00d2ff;
    box-shadow: 0 0 0.2vw #1fb5ac;
    cursor: pointer;
  }
  .icon-font{
    color: #3b79a1;
    position: absolute;
    right: 0.63vw;
    top: 0.68vw;
    margin-right: 0 !important;
    margin-top: 0 !important;
    transition: all .3s ease-in;
  }
  .drop-down:hover > i{
    color: #00d2ff;
  }
  .drop-down-content{
    position: absolute;
    width: 13vw;
    height: 0;
    overflow: auto;
    left: -0.05vw;
    top: 2.38vw;
    background-color: #1d2454;
    border: solid 1px #3b79a1;
    border-top: none;
    border-bottom: none;
    z-index: 9999;
    scrollbar-color: transparent transparent;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;
    scrollbar-width:none;
  }
  .drop-down-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  .drop-down-list-item{
    width: 100%;
    padding: 0.9vw 0.63vw;
  }
  .drop-down-list-item:hover{
    background: #383f6e;
  }
  .drop-down-list-item-active{
    background: #474e7f;
  }
  .up{
    animation:upSile .5s forwards;
    -moz-animation:upSile .5s forwards; /* Firefox */
    -webkit-animation:upSile .5s forwards; /* Safari and Chrome */
    -o-animation:upSile .5s forwards; /* Opera */
  }
  .down{
    animation:downSile .5s forwards;
    -moz-animation:downSile .5s forwards; /* Firefox */
    -webkit-animation:downSile .5s forwards; /* Safari and Chrome */
    -o-animation:downSile .5s forwards; /* Opera */
  }
  @keyframes upSile {
    from{
      height: 0;
    }
    to{
      height: 9vw;
    }
  }
  @keyframes downSile {
    from{
      height: 300%;
    }
    to{
      height: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BaoKuo.vue